import { createFileRoute } from '@tanstack/react-router'

import { ProcessDocumentReviewPage } from '@/pages/_app/process-document/review/page'

export interface ValidatedSearchParams {
  taskId?: number
}

export const Route = createFileRoute('/process-document/review/$jobId')({
  component: ProcessDocumentReviewPage,
  validateSearch: (search): ValidatedSearchParams => {
    return {
      taskId: parseInt(search.taskId as string) || undefined,
    }
  },
})
